import defaultTheme from "./default";

import { responsiveFontSizes, unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core";
import { esES } from '@material-ui/core/locale';

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
      drawer: {
          width: number | string;
      };
  }
  interface ThemeOptions {
      drawer?: {
          width: number | string;
      };
  }
}

const overrides = {
  typography: {
    h1: {
      fontSize: "3rem",
    },
    h2: {
      fontSize: "2rem",
    },
    h3: {
      fontSize: "1.64rem",
    },
    h4: {
      fontSize: "1.5rem",
    },
    h5: {
      fontSize: "1.285rem",
    },
    h6: {
      fontSize: "1.142rem",
    },
    fontFamily: [
      'Poppins',
      'sans-serif'
  ].join(',')
  },
};

export default {
    default: responsiveFontSizes(createMuiTheme({ ...defaultTheme, ...overrides }, esES)),
};
